export function color_head() {
    return {
        backgroundColor: '#25223f',
        color: 'white',
        width: '20%', fontSize: 11,
    };
}

export function color_head_desc_mat(tipo) {
    const headerColor = 'rgb(37, 34, 63)';
    if (tipo === 'act') {
        return {
            backgroundColor: headerColor,
            color: 'white', fontSize: 13,
            width: '14%'
        };
    } else if (tipo === 'ob') {
        return {
            backgroundColor: headerColor,
            color: 'white', fontSize: 13,
            width: '21%'
        }
    } else if (tipo === 'asi') {
        return {
            backgroundColor: headerColor,
            color: 'white', fontSize: 13,
            width: '16%'
        }
    } else if (tipo === 'par') {
        return {
            backgroundColor: headerColor,
            color: 'white', fontSize: 13,
            width: '5%'
        }
    } else if (tipo === 'per') {
        return {
            backgroundColor: headerColor,
            color: 'white', fontSize: 13,
            width: '10%'
        };
    } else if (tipo === 'tipo') {
        return {
            backgroundColor: headerColor,
            color: 'white', fontSize: 13,
            width: '10%'
        };
    } else if (tipo === 'acc') {
        return {
            backgroundColor: headerColor,
            color: 'white', fontSize: 13,
            width: '9%'
        };
    } else if (tipo === 'hor') {
        return {
            backgroundColor: headerColor,
            color: 'white', fontSize: 13,
            width: '6%'
        };
    } else {
        return {
            backgroundColor: headerColor,
            color: 'white', fontSize: 13,
            width: '10%'
        };
    }
}

export function color_head_desc_act(tipo) {
    const headerColor = 'rgb(37, 34, 63)';
    if (tipo === 'act') {
        return {
            backgroundColor: headerColor,
            color: 'white', fontSize: 13,
            width: '12.5%'
        };
    } else if (tipo === 'tipo') {
        return {
            backgroundColor: headerColor,
            color: 'white', fontSize: 13,
            width: '12.5%'
        }
    } else if (tipo === 'ob') {
        return {
            backgroundColor: headerColor,
            color: 'white', fontSize: 13,
            width: '29%'
        }
    } else if (tipo === 'per') {
        return {
            backgroundColor: headerColor,
            color: 'white', fontSize: 13,
            width: '10%'
        };
    } else if (tipo === 'tipo') {
        return {
            backgroundColor: headerColor,
            color: 'white', fontSize: 13,
            width: '10%'
        };
    } else if (tipo === 'acc') {
        return {
            backgroundColor: headerColor,
            color: 'white', fontSize: 13,
            width: '10%'
        };
    } else if (tipo === 'hor') {
        return {
            backgroundColor: headerColor,
            color: 'white', fontSize: 13,
            width: '5%'
        };
    } else {
        return {
            backgroundColor: headerColor,
            color: 'white', fontSize: 13,
            width: '11%'
        };
    }
}
//Funcion para colocar color a las celdasde la tabla
export function color(rowIndex) {
    if (rowIndex % 2 === 0) {
        return {
            backgroundColor: 'white'
        };
    }
    return {
        backgroundColor: '#E7E7E7'
    };
}

export function toPostRequest(validacion) {
    //console.log('entro a to post request')
    //console.log(validacion)
    let response = {};
    response.anio = validacion.anio
    response.idValidacionDet = validacion.intIdValidacionDet
    response.totalHoras = validacion.totalHoras
    response.idPlanificadoUnidad = validacion.unidadPlanifica
    response.idCargaUnidad = "0"
    response.nivel = "0"
    response.termino = "0"
    response.tipoActividad = validacion.strTipoActividad
    response.actividad = validacion.strDescripcion
    response.descripcion = validacion.strObservacion
    response.fechaInicio = ""
    response.fechaFin = ""

    /* response.idAutoridad = currentUser.idpersona; */
    return response
  }

  export function getWeeksDiff(startDate, endDate) {
    const msInWeek = 1000 * 60 * 60 * 24 * 7;
  
    return Math.round(Math.abs(endDate - startDate) / msInWeek);
}

export function getSemestralDiff(startDate, endDate) {
    const msInSem = 1000 * 60 * 60 * 24 * 182;

    return Math.round(Math.abs(endDate - startDate) / msInSem);
}

export function getYearsDiff(startDate, endDate) {
    const msInYear = 1000 * 60 * 60 * 24 * 365;

    return Math.round(Math.abs(endDate - startDate) / msInYear);
}